import cn from 'classnames';
import s from './style.css';
import replace from 'string-replace-to-array';
import emojiRegex from 'emoji-regex';
import Emoji from 'components/Emoji';

const TextWithBackground = ({
	tag: Tag = 'span',
	children,
	bg,
	className,
	color,
	highlight = [],
	highlightColors = ['yellow'],
	link = 'people change their personality at work',
	url = 'https://www.totaljobs.com/insidejob/bringing-your-true-self-to-work/',
	link2 = 'you’re twice as likely',
	url2 = 'https://www.totaljobs.com/insidejob/lgbtq-people-continue-to-feel-displaced-in-the-workplace/',
	...rest
}) => {
	let match = -1;
	const strings = highlight.length
		? replace(
			children[0],
			new RegExp(highlight.join('|'), 'g'),
			(foundString, offset, test, blah) => {
				match = match + 1;
				return (
					<TextWithBackground bg={highlightColors[match]}>
						{foundString}
					</TextWithBackground>
				);
			}
		  )
		: [children[0]];

	const wrappedEmoji = replace(strings, emojiRegex(), string => (
		<Emoji>{string}</Emoji>
	));

	let wrappedLink = replace(wrappedEmoji, new RegExp(link, 'g'), string => (
		<a href={url} target="_blank" rel="noopener noreferrer">
			{string}
		</a>
	));

	wrappedLink = replace(wrappedLink, new RegExp(link2, 'g'), string => (
		<a href={url2} target={'_blank'} rel="noopener noreferrer">
			{string}
		</a>
	));

	const isStandardColor = [
		'white',
		'blue',
		'green',
		'yellow',
		'transparent'
	].includes(bg);

	const style = isStandardColor
		? null
		: {
			boxShadow: `0.2rem 0.2rem 0 ${bg}, -0.2rem -0.2rem 0 ${bg},
					0.2rem -0.2rem 0 ${bg}, -0.2rem 0.2rem 0 ${bg}`,
			backgroundColor: `${bg}`
		  };

	return (
		<Tag
			className={cn(s.textBG, {
				[className]: className,
				[s.textBGTransparent]: bg === 'transparent',
				[s.textBGBlue]: bg === 'blue',
				[s.textBGGreen]: bg === 'green',
				[s.textBGYellow]: bg === 'yellow'
				// [s.tight]: tight
			})}
			{...rest}
		>
			<span style={style}>{wrappedLink}</span>
		</Tag>
	);
};

export default TextWithBackground;



// WEBPACK FOOTER //
// ./components/TextWithBackground/index.js